import { SxProps, Theme, Typography, TypographyProps } from '@mui/material';
import { forwardRef } from 'react';
import { toSxArray } from 'src/utils/sx';

const captionSx: SxProps<Theme> = {
  fontSize: '0.65625rem',
  fontWeight: 600,
  letterSpacing: '0.09em',
  lineHeight: 'normal',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};

export type SidePanelCaptionProps = TypographyProps;

export const SidePanelCaption = forwardRef<HTMLSpanElement, SidePanelCaptionProps>(
  ({ children, sx, ...rest }, ref) => (
    <Typography ref={ref} variant="overline" sx={[captionSx, ...toSxArray(sx)]} {...rest}>
      {children}
    </Typography>
  ),
);

SidePanelCaption.displayName = 'SidePanelCaption';
